/*  ========================================================================
    # Hooks - Use Productions API
    ========================================================================  */

import { useEffect, useState } from 'react';

const useProductionsApi = params => {
  const [loadingProductions, setLoadingProductions] = useState(true);
  const [productionsCount, setProductionsCount] = useState(0);
  const [productions, setProductions] = useState([]);
  const paramsString = new URLSearchParams();

  const getProductions = async () => {
    setLoadingProductions(true);

    for (const [key, value] of Object.entries(params)) {
      if (key === 'categories') {
        if (value !== '') {
          paramsString.append(key, value);
        }
      } else {
        paramsString.append(key, value);
      }
    }

    try {
      const response = await fetch(`/wp-json/productions/v1/carditems?${paramsString.toString()}`);

      if (response.status !== 200) {
        throw new Error(await response.text());
      }

      const productions = await response.json();

      const mappedProductions = productions.map(production => ({
        id: production.id,
        image: production.image,
        title: production.title,
        segment: production.segment,
        description: production.description,
        url: production.url,
        nextDate: production.nextDate,
        subtitle: production.subtitle,
        video: production.video
      }));

      setLoadingProductions(false);
      setProductionsCount(parseInt(response.headers.get('X-WP-Total'), 10));
      setProductions(mappedProductions);
    } catch (error) {
      setLoadingProductions(false);
      console.log(error); // eslint-disable-line
    }
  };

  useEffect(() => {
    getProductions();
  }, [params.per_page, params.page, params.categories, params.search]);

  return { loadingProductions, productionsCount, productions };
};

export default useProductionsApi;
